import React from "react";
import styled from "styled-components";
import SortArrow from "../../elements/SortArrow";
import {rewardPeriodLabel} from "../../performance/period";
import LoggingLink from "../../elements/LoggingLink";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
`;

const PeriodSelector = styled.div`
    display: flex;
    cursor: pointer;
    flex-shrink: 0;
    padding-top: 5px;
    padding-bottom: 7px;
    width: 144px;
    
    &.current {
        color: #3b7433;
        border-bottom: 5px solid #3b7433;
        padding-bottom: 2px;
    }
`;

export const MorePeriodsText = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    padding-left: 20px;
`;

export const ArrowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 5px;
`;

const DropDownMenuContainer = styled.div`
    z-index: 10;
`;

const Menu = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 230px;
    overflow-y: auto;
    border: solid 1px #e2dede;
    background-color: white;
`;

export const MenuOptionLink = styled(LoggingLink)`
    cursor: pointer;
    text-decoration: none;    
    transition: background-color 0.2s ease;
    border-bottom: solid 1px #e2dede;
    
    :hover {
        background-color: #d6d0c8;
    }
`;

const MenuOption = styled.div`
    display: flex;
    justify-content: flex-start;
    padding-left: 20px;
    padding-top: 4px;
    padding-bottom: 4px;
    flex-shrink: 0;
    color: #9e9892;
    width: 105px;
`;

const MorePeriods = ({
                         periods,
                         isSelectedPeriod,
                         viewingOnDate,
                         periodPath,
                         loggingPayloadFor,
                         showMenu,
                         setShowMenu
                     }) => {

    function getRewardLabel(period) {
        return rewardPeriodLabel(period, viewingOnDate).toUpperCase();
    }

    const toPeriodLink = (period) => {
        const {periodBasis, startDate} = period;
        const key = `${periodBasis}/${startDate}`;
        const path = periodPath(periodBasis, startDate);
        const rewardLabel = getRewardLabel(period);
        return <MenuOptionLink to={path} key={key}
                               className="t-period-link"
                               loggingPayload={loggingPayloadFor(period)}>
            <MenuOption>{rewardLabel}</MenuOption>
        </MenuOptionLink>
    };

    const selectedPeriod = periods.find(p => isSelectedPeriod(p.periodBasis, p.startDate));
    const current = !selectedPeriod ? "" : "current";
    const menuText = !selectedPeriod ? "More Periods" : getRewardLabel(selectedPeriod);

    const menuComponent = !showMenu ? null : <DropDownMenuContainer>
        <Menu className="t-more-period-menu">
            {periods.map(toPeriodLink)}
        </Menu>
    </DropDownMenuContainer>;

    return <Container onClick={() => setShowMenu(!showMenu)}>
        <PeriodSelector className={`t-more-periods-menu ${current}`}>
            <MorePeriodsText className="t-more-periods-text">{menuText}</MorePeriodsText>
            <ArrowContainer>
                <SortArrow dir="DESC"/>
            </ArrowContainer>
        </PeriodSelector>
        {menuComponent}
    </Container>;
};

export default MorePeriods;